import { merge } from "lodash";

import { LOGOUT_USER } from "../store/user/user.constants";
import { Dispatcher } from "./dipatcher";
import { HttpException } from "./exceptions";

export class Util {
  static POSITIONS = [
    "First",
    "Second",
    "Third",
    "Fourth",
    "Fifth",
    "Sixth",
    "Seventh",
    "Eight",
    "Nineth",
    "Tenth",
    "Eleventh",
    "Twelveth",
    "Thirtheenth",
  ];

  static handleAxiosError(error, url) {
    if (error.isAxiosError) {
      const { data = {}, status } = error.response;
      const message = data.message || "";

      if (url !== "/login" && status === 401) {
        // Dispatcher.$dispatch({ type: LOGOUT_USER });
      }

      const exception = new HttpException(
        message,
        status,
        data.errors || data.error
      );

      throw exception;
    }

    throw error;
  }

  static parseQueryString(queryString = "") {
    queryString = queryString.replace("?", "");
    const keyValue = queryString.split("&");

    return keyValue.reduce((acc, cur) => {
      const [key, value] = cur.split("=");

      return merge(acc, { [key]: decodeURIComponent(value) });
    }, {});
  }

  static dispatchLogoutUser() {
    Dispatcher.$dispatch({ type: LOGOUT_USER });
  }

  static formatMoneyNumber(number) {
    if (!+number) return number;
    number = +number;

    // if (Math.abs(number) >= 1000) {
    //   return `${(number / 1000).toFixed(2)}k`;
    // }

    // if (Math.abs(number) >= 1000000) {
    //   return `${(number / 1000000).toFixed(2)}m`;
    // }

    // if (Math.abs(number) >= 1000000000) {
    //   return `${(number / 1000000000).toFixed(2)}b`;
    // }
    const value = (+number.toFixed(2)).toLocaleString();
    const hasPoint = value.includes(".");
    if (hasPoint) {
      return value;
    }
    return `${value}.00`;
  }

  static randomChoice(options) {
    return options[Math.floor(Math.random() * options.length)];
  }

  static generateRandomString(
    length = 10,
    factory = "abcdefghijklmnopqrstuvwxyz"
  ) {
    let string = "";

    while (string.length < length) {
      string += Util.randomChoice(factory.split());
    }

    return string;
  }

  static getFlutterCurrencyAndCountryFromUserCountry(country) {
    switch (country && country.toLowerCase()) {
      case "nigeria":
        return { currency: "NGN", country: "NG" };
      case "ghana":
        return { currency: "GHS", country: "GH" };

      default:
        return { currency: "USD", country: "US" };
    }
  }

  static get(name, defaultValue = null) {
    const val = localStorage[name];
    if (val) {
      return JSON.parse(val);
    }

    return defaultValue;
  }

  static set(name, value) {
    localStorage[name] = JSON.stringify(value);

    return value;
  }

  static noop(..._) {}

  static getCurrency() {
    const country = Util.get("userCountry");
    console.log("this the country", country);

    switch (country && country.toLowerCase()) {
      case "nigeria":
        return {
          currency: "₦",
          code: "NGN",
        };
      case "ghana":
        return {
          currency: "GH₵",
          code: "GHC",
        };
      default:
        return {
          currency: "$",
          code: "USD",
        };
    }
  }
}
